export default __webpack_public_path__ + "static/media/bollmann-overlay.1f05ea64.png";